import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import * as Sentry from "@sentry/angular";

import {AppModule} from './app/app.module';
import { environment } from './environments/environment';

Sentry.init({
	dsn: "https://b90b9463eb9bb08d202c70f9d8fdc066@sentry.ubique.ch/54",
	integrations: [],
	environment: environment.sentryEnvironment,
  });

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch(err => console.error(err));
